import config from 'config'
import lang from '@/lang'

export default {
  baseUrl: `${config.resourceHost}email/`,

  togglers: [
    {
      togglerName: 'useOwnEmailServer',
      togglerLabel: lang.emailSettings.sendViaOwnAccount,
      togglerLabelFunction: undefined,
      togglerReadOnlyFunction: () => (false),
    },
    {
      togglerName: 'useSyncEmailAccounts',
      togglerLabel: '',
      togglerLabelFunction: (isOrgamax) => lang.emailSettings.archiveImapEmails(isOrgamax),
      togglerReadOnlyFunction: (emailAccountsList) => (!emailAccountsList.some(({ hasImap }) => (hasImap))),
    },
  ],
}
